import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        width: "90%",
        margin: "0 auto",
    },
    title: {
        marginTop: "32px",
        fontFamily: "Open Sans",
        fontSize: "32px",
        fontWeight: "600",
        textAlign: "left",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    },
    actions: {
        display: "flex",
        marginTop: "24px",
    },
    addButton: {
        "&.MuiButtonBase-root": {
            background: theme.palette.info.light,
            color: "white",
            height: "36px",
            fontFamily: "Open Sans",
        },
    },
    statusButton: {
        borderRadius: "16px",
        padding: "10px",
        background: "rgba(0, 0, 0, 0.08)",
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Open Sans",
            paddingBottom: "5px",
        },
    },
}));
